import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="bold text-center mb-3">2014</p>


    <div class="poem">

      <p class="poem-block mb-3">
        Nun neniu verkas poemojn kun ritm’ kaj rimo. <br/>
        Nun neniu strebas al plej trafa kaj sole taŭga esprimo. <br/>
        Nun neniu desegnas projektojn arkitekturajn permane: <br/>
        Ĉiuj scias, ke fari tion estas elspezi la fortojn vane.
      </p>

      <p class="poem-block mb-3">
        Nun neniu scipovas kalkuli sen komputilo. <br/>
        Nun neniu sin sentas sekura, se en la poŝtelefon’ estingiĝis la pilo. <br/>
        Nun neniu arogus, eĉ sub la influ’ de l’ impeto <br/>
        Eldiri iun penson, kiu ne estus trovebla en Interreto.
      </p>

      <p class="poem-block mb-3">
        Nun neniu kredas al siaj propraj okuloj: <br/>
        Vero estas nur tio, kion diras al ni superuloj. <br/>
        Nun neniu eĉ penas pensi memstare: <br/>
        Per televid’ kaj Fejsbuk’ ni edukiĝas are.
      </p>
    </div>


    <p class="bold text-center mb-3 mt-3">2034</p>


    <div class="poem">

      <p class="poem-block mb-3">
        Nun neniu emas iri per propraj kruroj: <br/>
        Restis en fia pasint’ tiuj turmentoj teruraj, <br/>
        Kiam la tutan pezon de niaj korpoj plensangaj <br/>
        Devis elteni nur la par’ de maldikaj stangoj.
      </p>

      <p class="poem-block mb-3">
        Nun neniu emas manĝi laŭ propra gusto: <br/>
        Ja per la disbranĉigita ret’ de l’ komuna provizo justa <br/>
        Ĉiu ricevas porcion je la difinita horo <br/>
        Rekte al buŝo, tepidan kaj kun la racie kalkulita nutriv-valoro.
      </p>

      <p class="poem-block mb-3">
        Nun neniu scipovas legi – fi, kia atavismo! <br/>
        Ĉe kvarcent kvindek unu de Fahrenheit’, jam delonge fariĝis la fum’ ajna rismo. <br/>
        Restis nur la inform’, vid- kaj aŭdigata per retaj kanaloj, <br/>
        Kaj ŝanĝata konstante, pro ajnaj okazoj eventualaj.
      </p>

      <p class="bold text-center mb-3 mt-3">* * *</p>

      <p class="poem-block mb-3">
        Jen kion vidis mi, alveninta al Tero <br/>
        Fortinbras’ el fora planedo: nur degenero. <br/>
        Sed kie estas Hamlet’, la anim’ libera? <br/>
        Mi ne renkontis lin, eĉ mortigitan. Restas l’ afer’ senespera.
      </p>
    </div>
    `
  )
}


const itemName = {
  esp: 'Natura evoluo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;